import { Button, Flex, type ButtonProps } from "@mantine/core";
import { IconStar } from "@tabler/icons-react";
import { TRUSTPILOT_REVIEW_URL } from "@/shared/constants/trustpilot.const";
import type { ReviewPlatformSource } from "@shared/trustpilot";

type ReviewPlatformButtonsProps = Omit<ButtonProps, "component" | "href" | "target" | "rel" | "children"> & {
  onNavigate?: (platform: ReviewPlatformSource) => void;
  /** Stack vertically on narrow containers (e.g. mobile success banner). */
  stackOnMobile?: boolean;
  visiblePlatforms?: ReviewPlatformSource[];
};

export default function ReviewPlatformButtons({
  onNavigate,
  variant = "outline",
  size = "sm",
  stackOnMobile = false,
  visiblePlatforms = ["trustpilot"],
  fullWidth,
  ...buttonProps
}: ReviewPlatformButtonsProps) {
  const showTrustpilot = visiblePlatforms.includes("trustpilot");

  if (!showTrustpilot) return null;

  return (
    <Flex
      gap="xs"
      w={fullWidth ? "100%" : undefined}
      direction={stackOnMobile ? { base: "column", sm: "row" } : "row"}
      wrap={stackOnMobile ? "wrap" : "nowrap"}
      align="stretch"
    >
      {showTrustpilot ? (
        <Button
          component="a"
          href={TRUSTPILOT_REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          variant={variant}
          size={size}
          leftSection={<IconStar size={16} />}
          onClick={() => onNavigate?.("trustpilot")}
          style={{ flex: "1 1 0", minWidth: 0 }}
          {...buttonProps}
        >
          Rate us on Trustpilot
        </Button>
      ) : null}
    </Flex>
  );
}
